import ReactDOM from "react-dom/client";
import App from "App";

// i18n
import "./i18n";

// Styles
// import "assets/styles/index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
